/**
 * A minimal unified-diff renderer with +/- line colouring. Shared by the
 * optimization guidance modal and the NIS2 compliance fix modal so both render
 * the exact change identically.
 */
export function DiffBlock({ diff }: { diff: string }) {
  return (
    <pre className="overflow-x-auto rounded-md border border-hairline bg-surface-2/60 p-3 text-[0.7rem] leading-relaxed">
      {diff.split('\n').map((line, i) => {
        const fileHeader =
          line.startsWith('+++') || line.startsWith('---') || line.startsWith('diff ');
        const add = line.startsWith('+') && !line.startsWith('+++');
        const del = line.startsWith('-') && !line.startsWith('---');
        const hunk = line.startsWith('@@');
        return (
          <div
            key={i}
            className={
              fileHeader
                ? 'font-semibold text-bone'
                : add
                  ? 'text-iris'
                  : del
                    ? 'text-danger'
                    : hunk
                      ? 'text-info'
                      : 'text-haze'
            }
          >
            {line || ' '}
          </div>
        );
      })}
    </pre>
  );
}
